import React, { Component } from 'react';

import { WithStyles, withStyles } from '@mui/styles';

import APHeading from './../../components/atoms/APHeading';
import APLabel from './../../components/atoms/APLabel';
import { withTranslate } from '../../core/TenantProvider';

import MailSentSvg from './assets/mail-sent.svg';
import BecomePartnerCompleteStyles from './styles/BecomePartnerComplete.style';
import { TriggerGoogleAnalytics4Tag, TriggerGoogleAnalyticsTag } from '../../core/utils/GoogleAnalyticTag';
import { GoogleAnalyticTags } from '../../core/utils/GoogleAnalyticTag/GoogleAnalyticsTags';
import { GoogleAnalytics4Tags } from '../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags';

interface BecomePartnerCompleteProps extends WithStyles<typeof BecomePartnerCompleteStyles> {
    onReturn?: any,
    translate: Function,
    title: string,
    referralLink?: string,
    settings: any
}

class BecomePartnerComplete extends Component<BecomePartnerCompleteProps, {}> {
    state = {
    };

    componentDidMount() {
        TriggerGoogleAnalyticsTag(
            GoogleAnalyticTags.eventAction.load,
            GoogleAnalyticTags.registration.load.registrationComplete
        );
        TriggerGoogleAnalytics4Tag(
            GoogleAnalytics4Tags.registrationV2.name,
            GoogleAnalytics4Tags.eventAction.load,
            GoogleAnalytics4Tags.registrationV2.load.registrationComplete
        );
    }

    render() {
        const {
            classes,
            translate,
            settings
        } = this.props;

        return (
            <div className={classes.BecomePartnerCompleteContainer}>
                <div className={classes.BecomePartnerCompleteCopy}>

                    <APHeading className={classes.title} variant="h4">
                        {translate('become.partner.complete.title', {
                            name: settings.ORG_NAME
                        })}
                    </APHeading>
                    <APLabel className={classes.titleParagraph}>
                        {translate('become.partner.complete.title.paragraph')}
                    </APLabel>

                    <img className={classes.mailIcon} src={MailSentSvg} alt="mail" />

                    <APLabel className={classes.titleParagraph}>
                        {translate('become.partner.complete.subtite.paragraph')}
                    </APLabel>

                    <a href={settings.ORG_URL} className={classes.link}>
                        {translate('become.partner.complete.linkText')}
                    </a>
                </div>

            </div>
        );
    }
}

export default withTranslate(
    withStyles(BecomePartnerCompleteStyles)(BecomePartnerComplete)
);